<template>
   <div class="tops hovers" id="topss">
    <p>
      <span @click="returns(1)">首页</span>
      <span><img src="../assets/you.png" alt=""></span>
      <span @click="returns(2)">产品</span>
      <span><img src="../assets/you.png" alt=""></span>
      <span class="lastspan">魔蚊特灭蚊器</span>
    </p>
  </div>
  <div class="centers">
    <div class="box1">
      <div class="mask">
        <img src="../assets/shuibo.png" alt="">
      </div>
      <div class="box1l">
        <img src="../assets/mowen1.png" alt="">
      </div>
      <div class="box1r">
       <h3>魔蚊特®灭蚊器</h3>
       <p>触控式按钮</p>
       <p>360°诱蚊灯</p>
       <p>USB插电方式</p>
       <p>静音灭蚊</p>
       <p>顶部/底部可拆卸,易于清理</p>
       <p>无毒无害</p>
       <div class="btns hovers" >
        <span  class="">购 买</span>
       </div>
      </div>
    </div>
    <div class="box2 boxs">
      <h5>使用教程</h5>
      <video  controls poster="../assets/videomask.png">
         <source src="../assets/videos.mp4" type="video/mp4" >
      </video>
    </div>
    <div class="box3 boxs">
        <h5>工作原理</h5>
        <div class="ims">
          <img src="../assets/chanpin2.png" alt=""> 
          <div class="xians xian1"></div>
          <div class="xians xian2"></div>
          <div class="xians xian3"></div>
          <div class="xians xian4"></div>
          <div class="xians xian5"></div>
        </div>
        <div class="lis1 lis">
            <p>储蚊盒</p>
            <span>倒斗式设计防止蚊虫逃逸</span>
        </div>
        <div class="lis2 lis">
            <p>风扇</p>
            <span>蚊子靠近灭蚊器时，风扇将它吸入储蚊盒里，吸入的蚊子会被困住</span>
        </div>
        <div class="lis3 lis">
            <p>储水盒</p>
            <span>由于雌蚊在吸血后需要找水源产卵，水是引诱蚊子的强引诱剂。</span>
            

            
        </div>
        <div class="lis4 lis">
            <p>诱蚊剂</p>
            <span>蚊子被诱蚊剂挥发出的二氧化碳引诱到灭蚊器中。蚊子依靠各种线索来寻找宿主，包括人呼出的二氧化碳、体味、汗和体温。</span>
        </div>
        <div class="lis5 lis">
            <p>360°诱蚊灯</p>
            <span>强紫外线引诱蚊子飞向灭蚊器</span>
            

            
        </div>
    </div>
    <div class="box4 boxs">
      <h5>USB充电</h5>
      <div class="box4all">
        <div class="box4l"><img src="../assets/us1.png" alt=""></div>
        <div class="box4r"> 
          <div class="box4rimg">
            <div class="imsr">
              <img src="../assets/us2.jpg" alt="">
            </div>
            <div class="imsr">
              <img src="../assets/us3.jpg" alt="">
            </div>
            <div class="imsr">
              <img src="../assets/us4.jpg" alt="">
            </div>
          </div>
          <p>该灭蚊器配备USB接口，可以使用电脑USB端，充电宝，壁式USB充电器，或任何USB插座能为其供电。通用 USB 电源接口适合家庭/办公室使用，便于在户外或旅行中随身携带和使用。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from 'vue';

  export default {
    data(){
      return{
        options:{
          src: "../assets/videos.mp4", //视频源
  poster: '', //封面
        }
      }
    },
    methods:{
      returns(e) {

if (e == 1) {
  this.$router.push({ path: "/" })

}
if (e == 2) {
  this.$router.push({ path: '/Chanpin' })
}

},
    },
    created(){
    },
    mounted(){}
 }
</script>

<style scoped>

.box1{
  /* background: url(../assets/shuibo.png) no-repeat center; */
  /* background-size: cover;
  border: 1px solid; */
  position: relative;
  height: 100vh;
  /* width: 100vw; */
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* border: 3px solid blueviolet; */
  overflow: hidden;
  box-sizing: border-box;
}
.mask{
  box-sizing: border-box;

  position: absolute;
  width: 100%;
  height:80vh;
  left: 0;
  bottom: 0;
  z-index: -1;
  /* border: 1px solid red; */
  overflow: hidden;
}
.mask img{
  width: 100%;
  /* height: 100%; */
}
.box1l{
  /* border: 2px solid yellow; */
  width: 40%;
}
.box1l img{
  width: 100%;
}
.box1r{
  /* border: 1px solid red; */
  width: 47%;
  /* border: 1px solid; */
}
.box1r h3{
  font-size: 2rem;
  margin-bottom: 3rem;
  letter-spacing: 5px;
}
.box1r p{
  letter-spacing: 0.2rem;
  line-height: 1.6;
  margin: 1.2rem 0;
  margin-left: 2rem;
  font-size: 0.8rem;
  font-weight: 550;
  position: relative;
}
.box1r p::after{
position: absolute;
content: "";
width: 0.8rem;
height: 0.8rem;
background: url(../assets/duihao2.png) no-repeat center;
background-size: cover;
left: -1.5rem;
top: 50%;
transform: translateY(-50%);
}
.box1r .btns{
  /* border: 1px solid red; */
  display: inline-block;
  padding: 0.5rem 2rem;
  font-size: 0.8rem;
  background: #2180D1;
  color: #F1F9FF;
  margin-left: 1.5rem;
 
}
.box2{
  width: 65vw;
  margin: auto;
  overflow: hidden;
  /* border: 2px solid blue; */
  margin-top: 4rem;
  margin-bottom: 3rem;
}
video{
  box-sizing: border-box;
  font-size: 0;
  background: #fff;
width: 100%;
object-fit: fill;
display: block;

}
video:focus {
outline:none;
}
.box3{
  width:65%;
  margin: 2rem auto;
  /* border: 1px solid ; */
  position: relative;
  padding-bottom: 5rem;
}
h5{
  font-size: 1.2rem;
  font-weight: bold;
  line-height: 2;
}
.box3 .ims{
  width: 54%;
  /* border: 1px solid yellow; */
  margin-left: 10%;
  position: relative;
}
.ims img{
  width: 100%;
}
.lis{
  width: 20%;
  /* background: pink; */
  position: absolute;
  box-sizing: border-box;
  padding: 0 0.5rem;
}
.lis p{
  font-size: 0.8rem;
  font-weight: bold;
  text-align: center;
  margin-bottom: 0.5rem;
}
.lis span{
  font-size: 0.6rem;
  text-align: center;
  display: block;
  line-height: 1.2;
}
/* .lis::after{
  position: absolute;
  content: "";
  
  background:url(../assets/xian.png) no-repeat center;
  background-size: cover;
} */

.xians{
  height: 1.5px;
  width: 30%;
  background: #2180D1;
  position: absolute;
  z-index: 30;
}
.xians::after{
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  content: "";
  width: 10px;
  height: 10px;
  background-color: #2180D1;
  border-radius: 50%;
  overflow: hidden;
}
.lis1{
  /* width: 32%; */
  padding: 0 1rem;
  right: 15%;
  top: 10%;
}

.lis2{
  /* padding: 0 1rem; */
  left: 0%;
  top: 25%;
}

.lis3{
  /* padding: 0 0.5rem; */
  left: 0%;
  top: 60%;
}
.lis4{
  /* width: 30%;   */
  /* padding: 0 1rem; */
  right: 15%;
  top: 55%;
}
.lis5{
  /* width: 32%; */
  /* padding: 0 1rem; */
  right: 48%;
  top: 85%;
}

.xian1{
top: 8%;
right: -5%;
}
.xian2{
top: 30%;
left: 18%;
transform: rotateZ(180deg);
}
.xian3{
width: 42%;
bottom: 25%;
left: -25%;
transform-origin:100%;
transform: rotateZ(180deg);
}
.xian4{
width: 36%;
top: 75%;
right: -1%;
transform-origin:0%;
transform: rotateZ(0deg);
}
.xian5{
width: 20%;
top: 78%;
right: 20%;
transform-origin:0%;
transform: rotateZ(90deg);

}
.box4{
  width: 65vw;
  margin: auto;
}
.boxs{
  width: 75vw;
}
.box4l{
  width: 38%;
}
.box4l img{
  width: 100%;
}
.box4all{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}
.box4r{
  width: 55%;
  /* border: 1px solid red; */
}
.box4rimg{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}
.imsr{
  width: 11vw;
  height: 11vw;
  /* border: 1px solid red; */
  border-radius: 50%;
  overflow: hidden;
  position: relative;
  box-shadow: 0px 0px 3px #2c2c2c;
}
.imsr img{
  height: 100%;
  width: auto;

  position: absolute;
  right: 0;
  top: 0;

}
.box4r p{
  font-size: 0.8rem;
  line-height: 1.6;
  color: #3b3c3c;
}
</style>